export const Tags: Record<string, string> = {
  new: "NEW",
  "poor-deal": "POOR DEAL",
  "good-deal": "GOOD DEAL",
  "great-deal": "GREAT DEAL",
  "buy-box": "BUY BOX",
}
